import { ThemeProviderWrapper, I18nProvider } from '@common-ui-library/shared';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import EleosAdminPortalApp from './EleosAdminPortal';
import { adminPortalStrings } from './strings';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProviderWrapper>
      <I18nProvider namespace="adminPortal" resources={adminPortalStrings}>
        <BrowserRouter>
          <EleosAdminPortalApp />
        </BrowserRouter>
      </I18nProvider>
    </ThemeProviderWrapper>
  </React.StrictMode>
);
